/**
 * @generated SignedSource<<719a5aaaaa70806dda40cdf727e40c5d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ListItemAssignees_roles$data = ReadonlyArray<{
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"ListItemRoles_roles">;
  readonly " $fragmentType": "ListItemAssignees_roles";
}>;
export type ListItemAssignees_roles$key = ReadonlyArray<{
  readonly " $data"?: ListItemAssignees_roles$data;
  readonly " $fragmentSpreads": FragmentRefs<"ListItemAssignees_roles">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "ListItemAssignees_roles",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ListItemRoles_roles"
    }
  ],
  "type": "EmployeeRole",
  "abstractKey": null
};

(node as any).hash = "bf617dcd34f68633d703ffdf70167829";

export default node;
